export const mappings = {
  "en-CA": "eng",
  "fr-CA": "fre",
  en: "eng",
  fr: "fre",
};
